import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LetterWriteFileListFileRowComponent } from './file-row.component';
import { LetterWriteFileListFileNameTextModule } from '../file-name-text/index';
import { FileModule } from '@schoolbelle/api/file';

@NgModule({
  declarations: [
    LetterWriteFileListFileRowComponent,
  ],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule, 
    FileModule,
    LetterWriteFileListFileNameTextModule,
  ],
  exports:[
    LetterWriteFileListFileRowComponent,
  ]
})
export class LetterWriteFileListFileRowModule { }
